import { Component, Input } from '@angular/core';

import { IconComponent } from '@atoms/icon/icon.component';

@Component({
  selector: 'app-box-section',
  imports: [IconComponent],
  templateUrl: './box-section.component.html',
  styleUrl: './box-section.component.scss',
})
export class BoxSectionComponent {
  @Input() title?: string;
  @Input() type: 'default' | 'modern' = 'default';
  @Input() icon?: string;
  @Input('align-items') alignItems?: 'top' | 'center' | 'bottom';
}
